import { getIngredientHeaderButtons } from 'components/ingredients/IngredientUtils';
import { GetIngredientHeaderButtonsParams } from 'components/ingredients/IngredientConstants';
import { IDropDownList } from 'components/customComponents/CommonComponents/RMDropDownList';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { showAlertSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { useSelectedIngredientRows } from 'redux/hooks/IngredientDetail';
export interface Props {
  modelRefCurrent: any;
  onClickMergeIngredient: () => void;
  addIngredientType: () => void;
  addVendor: () => void;
  addLiquidClass: () => void;
  printLabels: () => void;
  exportsList: IDropDownList[];
  showDeleteIngredientWarning: () => void;
  openIngredient: () => void;
  createIngredient: () => void;
  addProteinType: () => void;
}

const useIngredientHeaderButtons = (props: Props) => {
  const {
    modelRefCurrent,
    onClickMergeIngredient,
    addIngredientType,
    addVendor,
    addLiquidClass,
    printLabels,
    exportsList,
    showDeleteIngredientWarning,
    openIngredient,
    createIngredient,
    addProteinType,
  } = props;
  const selectedRows = useSelectedIngredientRows();
  const mergeIngredients = () => {
    if (selectedRows) {
      const bufferCount = selectedRows.filter(
        (ing) => !!ing.defaultBufferIngredientStockId,
      ).length;
      if (bufferCount === 1) {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          'You cannot merge a buffer with a non-buffer.',
        );
      } else {
        onClickMergeIngredient();
      }
    }
  };

  const ingredientHeaderButtonsParams: GetIngredientHeaderButtonsParams = {
    isDisabled: false,
    modelRefCurrent,
    addIngredientType,
    addVendor,
    addLiquidClass,
    printLabels,
    exportsList,
    mergeIngredients,
    isMergeIngredientDisabled:
      selectedRows.length !== 2 ||
      (selectedRows.length === 2 && selectedRows[0]?.id === selectedRows[1]?.id),
    isDeleteDisabled: selectedRows.length < 1,
    showDeleteIngredientWarning,
    openIngredient,
    isOpenIngredientDisabled: selectedRows?.length != 1,
    createIngredient,
    addProteinType,
  };

  const ingredientHeaderButtons: RMCustomButtonProps[] = getIngredientHeaderButtons(
    ingredientHeaderButtonsParams,
  );

  return { ingredientHeaderButtons };
};

export default useIngredientHeaderButtons;
